<!-- 社内监督 -->
<template>
  <div id="AboutUs">
    <headerVue></headerVue>
    <div class="container">
      <div class="bottom">
        <div>
          <h2>社内监督邮箱：93shx@163.com</h2>
          <h2>联系电话：63903370 <span>|</span> 63903380</h2>
        </div>
      </div>
    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import headerVue from '../index/header.vue'
import footerVue from '../foot/foot.vue'
export default {
  name: 'Snjd',
  data() {
    return {
      basicInfo: [],
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      let res = await this.$api.nav.getFooterInfo()
      // console.log('rrrrrrrrrrres',res);
      this.basicInfo = res.data.siteBaseInfo
      // console.log('基本信息', this.basicInfo);
    }
  },
  components: {
    headerVue,
    footerVue
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  height: 500px;
  margin: auto;
  background-color: white;
  margin-top: 20px;

  .title {
    padding: 10px;
    padding-bottom: 20px;
    font-size: 20px;
    text-align: center;
    letter-spacing: 1px;
  }

  .content {
    height: 360px;
    display: flex;
    justify-content: space-between;
    width: 1000px;
    background-color: #3282D2;
    margin: auto;
    margin-bottom: 20px;
    margin-top: 30px;

    .left {
      margin: auto;
      text-align: center;
      line-height: 60px;
      flex: 1;

      p {
        color: white;
        font-size: 13px;
      }
    }

    .right {
      flex: 1;

      img {
        width: 600px;
      }
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 450px;
    width: 1000px;
    margin: auto;
    text-align: center;
    h2{
      margin-bottom: 50px;
    }
    p {
      font-size: 17px;
      line-height: 35px;
      color: #3C3C3C;
    }

    span {
      color: #6a6a6a;
      font-weight: lighter;
      padding: 5px;
    }
  }
}
</style>